import * as urlWebservice from "utils/apis"
import * as actionsWebservice from "utils/functions/httpMethods"

// Find all companies
export const findAllCompanies = async () => {
  try {
    const res = await actionsWebservice.get(urlWebservice.FIND_ALL_COMPANIES)
    return res
  } catch (error) {
    throw new Error(error)
  }
}
